import React from 'react';

/**
 * VerifiedBadge — small blue check displayed next to a creator's display name.
 * Only rendered when `show` is truthy so callers can inline it: `{v && <VerifiedBadge/>}`.
 *
 *   <span>{creator.display_name} <VerifiedBadge show={creator.verified} /></span>
 *
 * `size` accepts 'sm' | 'md' (default 'sm').
 */
export function VerifiedBadge({ show = true, size = 'sm', title = 'Verified creator', className = '' }) {
  if (!show) return null;
  return (
    <span
      className={`verified-badge verified-badge-${size} ${className}`.trim()}
      title={title}
      aria-label="Verified"
      data-testid="verified-badge"
    >
      ✓
    </span>
  );
}

export default VerifiedBadge;
